import Layout from '@/layout'

const minipUserRouter = {
  path: '/minip_user/',
  component: Layout,
  name: 'minipUser',
  meta: {
    title: '小程序用户管理',
    icon: 'el-icon-mobile',
    roles: ['root']
  },
  children: [
    {
      path: 'auth_access_apply_record',
      name: 'authAccessApplyRecord',
      component: () => import('@/views/minip/user/authAccessApplyRecord'),
      meta: {title: '报价授权申请', icon: 'el-icon-s-unfold', noCache: true}
    },
    {
      path: 'auth_access_success_record',
      name: 'authAccessSuccessRecord',
      component: () => import('@/views/minip/user/authAccessSuccessRecord'),
      meta: {title: '报价授权通过记录', icon: 'el-icon-s-fold', noCache: true}
    }
  ]
}
export default minipUserRouter
